// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes';
import CourierRoutes from './courierRoutes';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const App = () => {
  const currentPath = window.location.pathname;

  return (
    <AuthProvider>
      <Router basename={currentPath.startsWith('/warehouse') ? '/warehouse' : '/courier'}>
        {currentPath.startsWith('/warehouse') ? <AppRoutes /> : <CourierRoutes />}
        <ToastContainer />
      </Router>
    </AuthProvider>
  );
};

export default App;
// "npm --prefix \"$RESOURCE_DIR\" run lint"
